module.exports = __webpack_public_path__ + "img/thumbnail_IndianPeafowl_j_albino.ccd7561b.png";